import { Component, OnDestroy, OnInit } from '@angular/core';
import {EventService} from "../../../core/services/event.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {UiStateService} from "../../../core/services/ui-state.service";
import {ToolboxContentResolver} from "../../../core/resolver/toolbox-content.resolver";
import {ProgressService} from "../../../core/services/progress.service";
import {Angulartics2} from "angulartics2";

@Component({
  selector: 'app-participant-resources',
  templateUrl: './participants-resources.html',
  styleUrls: ['./participants-resources.scss']
})
export class ParticipantResourcesComponent implements OnInit, OnDestroy {
  fundraisingToolboxContent: any = [];
  firstHours: any = {};
  firstSteps: any = {};
  tips: any = [];
  isTeam: boolean;
  downloads: any = {};
  participantLabel: string;
  activeTab: string;
  downloadsContent: any = [];
  private eventSubscription;

  constructor(public eventService: EventService,
              public activatedRoute: ActivatedRoute,
              public uiStateService: UiStateService,
              private router: Router,
              private progressService: ProgressService,
              private angulartics2: Angulartics2) {
    this.eventSubscription = this.eventService.onEventChange.subscribe(event => {
      this.progressService.startProgress(false);
      this.eventService.getToolboxContent(this.getAdoptedEventId()).subscribe(res => {
        this.fundraisingToolboxContent = res.AdoptedEvent[0]['tieredToolboxContent'];
        this.downloadsContent = res.AdoptedEvent[0]['tieredDocuments'];
        this.initToolboxContent();
      })
      this.participantLabel = this.uiStateService.changeParticipantLabel(this.eventService.selectedEvent.cssClass);
    });
  }

  ngOnInit() {
    this.fundraisingToolboxContent =  this.activatedRoute.snapshot.data['fundraisingToolboxContent'].tieredToolboxContent;
    this.downloadsContent = this.activatedRoute.snapshot.data['fundraisingToolboxContent'].tieredDocuments;
    this.activatedRoute.params.subscribe((params: Params) => {
      this.isTeam = params['isTeam'] === 'team';
    });
    this.initToolboxContent();
    this.participantLabel = this.uiStateService.changeParticipantLabel(this.eventService.selectedEvent.cssClass);
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.activeTab = params['activeTab'];
    });
    this.angulartics2.eventTrack.next({
      action: 'Edit Insurance',
      properties: {category: 'Profile'}
    });
  }

  ngOnDestroy() {
    this.eventSubscription.unsubscribe();
  }

  getAdoptedEventId() {
    return this.eventService.selectedEvent.gql.Participant[0].adoptedEvent.adoptedEventId;
  }

  initToolboxContent() {
    this.firstHours = null;
    this.firstSteps = null;
    this.downloads = null;

    this.tips = this.eventService.selectedEvent.gql.Participant[0].adoptedEvent.fundraisingTips;

    this.downloadsContent.forEach(item => {
      if (this.isTeam) {
        if (item['sysTemplateTypeName'] === 'DOCUMENTS_CAPTAIN') {
          this.downloads = item;
        }
      } else {
        if (item['sysTemplateTypeName'] === 'DOCUMENTS') {
          this.downloads = item;
        }
      }
    });

    this.fundraisingToolboxContent.forEach(item => {
      if (this.isTeam) {
        if (item['sysTemplateTypeName'] === 'FR_ETOOLS_CAPTAIN_PAGE_2') {
          this.firstHours = item;
        } else if (item['sysTemplateTypeName'] === 'FR_ETOOLS_CAPTAIN_PAGE_1') {
          this.firstSteps = item;
        }
      } else {
        if (item['sysTemplateTypeName'] === 'FR_ETOOLS_PAGE_2') {
          this.firstHours = item;
        } else if (item['sysTemplateTypeName'] === 'FR_ETOOLS_PAGE_1') {
          this.firstSteps = item;
        }
      }
    });
    this.progressService.stopProgress(false);
  }

}
